export const CREATE_ADVANCEDREPORTSCHEDULE = 'CREATE_ADVANCEDREPORTSCHEDULE';
export const DELETE_ADVANCEDREPORTSCHEDULE = 'DELETE_ADVANCEDREPORTSCHEDULE';
export const SAVE_ADVANCEDREPORTSCHEDULE = 'SAVE_ADVANCEDREPORTSCHEDULE';
export const GET_ADVANCEDREPORTSCHEDULE = 'GET_ADVANCEDREPORTSCHEDULE';
export const UPDATE_ADVANCEDREPORTSCHEDULES_LIST = 'UPDATE_ADVANCEDREPORTSCHEDULES_LIST';
export const UPDATE_ADVANCEDREPORTSCHEDULES_TOTAL_COUNT = 'UPDATE_ADVANCEDREPORTSCHEDULES_TOTAL_COUNT';
